$(document).ready(function () {
  $(document).on("click", ".tab-main-list-bas li", function (e) {
    // remove active class from all li
    $(".tab-main-list-bas li").removeClass("active");

    // add active class to clicked li
    $(this).addClass("active");
    // get the data-tab attribute of clicked li
    var tabId = $(this).data("id");

    $(".bas-tab-item").hide();
    $(".bas-tab-item." + tabId).show();
  });

  $("body.template-page.better-aging-serum .product-info__description").each(function () {
    var $pTag = $(this).find("p").first(); // Just the first <p>
    var fullText = $pTag.text();
  
    if (fullText.length > 150) {
      var shortText = fullText.substring(0, 150) + "...";
  
      // Store full text in a data attribute for later use
      $pTag.addClass("full-text").hide(); // hide full text
  
      // Add preview text with "Read More"
      var previewHtml = `
        <p class="preview-text">
          ${shortText} <a href="#" class="read-more-link">Read More</a>
        </p>
      `;
  
      // Add "Read Less" inside the full text block
      var fullHtml = `
        <p class="full-text">
          ${fullText} <a href="#" class="read-less-link">Read Less</a>
        </p>
      `;
  
      // Replace the original <p> with new elements
      $(this).empty().append(previewHtml).append(fullHtml);
      $(this).find(".full-text").hide();
    }
  });
  
  // Show full text
  $(document).on("click", ".read-more-link", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".product-info__description");
    $container.find(".preview-text").hide();
    $container.find(".full-text").show();
  });
  
  // Show preview text
  $(document).on("click", ".read-less-link", function (e) {
    e.preventDefault();
    const $container = $(this).closest(".product-info__description");
    $container.find(".full-text").hide();
    $container.find(".preview-text").show();
  });
  
});

(function() {
    const revealImages = () => {
      document.querySelectorAll('.image-animate-reveal').forEach(img => {
        if (img.complete) img.classList.add('is-loaded');
      });
    };
    // Run on initial load
    window.addEventListener('load', revealImages);
    // Run when Shopify Theme Editor updates a section
    document.addEventListener('shopify:section:load', revealImages);
  })();

document.addEventListener("DOMContentLoaded", () => {
  const init = () => {
    const crispChat = document.querySelector('#crisp-chatbox-chat');
    const cornerCart = document.querySelector('.widgets-by-corner.corner-widget #corner-cowi-cart-button-launcher-wrapper');

    if (!crispChat || !cornerCart) return setTimeout(init, 500); // retry until both exist

    const originalZ = window.getComputedStyle(cornerCart).zIndex;

    const updateZIndex = () => {
      const isVisible = crispChat.getAttribute('data-visible') === 'true';
      cornerCart.style.setProperty('z-index', isVisible ? '0' : originalZ, 'important');
    };

    updateZIndex();
    new MutationObserver(updateZIndex).observe(crispChat, { attributes: true, attributeFilter: ['data-visible'] });
  };

  init();
});


(function setupSplideGlobalTouchFix() {
  // Only do anything if there is at least one Splide on the page
  if (!document.querySelector('.splide')) return;

  // Non-passive touchmove: tells Chrome/Android "JS might handle this"
  window.addEventListener(
    'touchmove',
    function (e) {
      if (!e.target.closest('.splide')) return;
      // No preventDefault here – the important bit is passive:false.
    },
    { passive: false }
  );

  // Same for wheel (mouse wheel / trackpad inside sliders)
  window.addEventListener(
    'wheel',
    function (e) {
      if (!e.target.closest('.splide')) return;
    },
    { passive: false }
  );
})();

// Swiper-like global touch behaviour for ALL Splide sliders
(function () {
  if (!window.Splide || window.Splide.__swiperLikePatchApplied) return;
  window.Splide.__swiperLikePatchApplied = true;

  // --- Optional global defaults that make dragging feel nicer ---
  window.Splide.defaults = window.Splide.defaults || {};
  Object.assign(window.Splide.defaults, {
    // Don't block new interactions while transition is running
    waitForTransition: false,
    // Require a bit of horizontal movement to start dragging
    dragMinThreshold: {
      mouse: 0,
      touch: 10,
    },
  });

  let startX = 0;
  let startY = 0;
  let isTracking = false;
  let gestureType = null; // "vertical" | "horizontal" | null

  // Start of a gesture
  document.addEventListener(
    'touchstart',
    function (e) {
      if (!e.touches || e.touches.length !== 1) return;

      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      isTracking = true;
      gestureType = null;
    },
    { passive: true, capture: true }
  );

  // Decide if this gesture is vertical or horizontal
  document.addEventListener(
    'touchmove',
    function (e) {
      if (!isTracking || !e.touches || e.touches.length !== 1) return;

      const t = e.touches[0];
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);

      // Don't decide too early – tiny jitter
      if (!gestureType) {
        if (dx < 4 && dy < 4) return; // small noise, ignore
        gestureType = dy > dx ? 'vertical' : 'horizontal';
      }

      // If this gesture is vertical, block ALL Splide sliders from seeing it
      if (gestureType === 'vertical') {
        const splideRoot = e.target.closest('.splide');
        if (splideRoot) {
          // Stop the event before it hits Splide's listeners
          e.stopPropagation();
          // IMPORTANT: do NOT preventDefault → browser can scroll normally
        }
      }
    },
    { passive: true, capture: true } // capture so we run before Splide handlers
  );

  // End gesture
  document.addEventListener(
    'touchend',
    function () {
      isTracking = false;
      gestureType = null;
    },
    { passive: true, capture: true }
  );
})();

// Universal patch: while a slide is moving, block Splide from receiving touches
(function () {
  if (!window.Splide || window.Splide.__scrollBlockerPatched) return;
  window.Splide.__scrollBlockerPatched = true;

  var originalMount = window.Splide.prototype.mount;

  window.Splide.prototype.mount = function (Extensions, Transition) {
    var instance = originalMount.call(this, Extensions, Transition);

    var root  = this.root;
    if (!root) return instance;

    var track = root.querySelector('.splide__track');
    if (!track) return instance;

    // Make sure track can host an absolutely positioned child
    if (getComputedStyle(track).position === 'static') {
      track.style.position = 'relative';
    }

    var blocker = null;

    function addBlocker() {
      if (blocker) return;

      blocker = document.createElement('div');
      blocker.className = 'splide-scroll-blocker';

      Object.assign(blocker.style, {
        position: 'absolute',
        inset: '0',
        zIndex: '1',           // under your arrows (z-index: 2) but above slides
        pointerEvents: 'auto',
        touchAction: 'pan-y',  // allow vertical scroll
        background: 'transparent'
      });

      track.appendChild(blocker);
    }

    function removeBlocker() {
      if (blocker && blocker.parentNode) {
        blocker.parentNode.removeChild(blocker);
      }
      blocker = null;
    }

    // When Splide starts moving to another slide
    this.on('move', function () {
      addBlocker();
    });

    // When the movement finishes
    this.on('moved', function () {
      removeBlocker();
    });

    // Safety: on destroy
    this.on('destroy', function () {
      removeBlocker();
    });

    return instance;
  };
})();
